import GalaxyWebhookSourceIcon from "../../assets/components/sources/GalaxyWebhookSourceIcon";

const GalaxyWebhookIcon = ({ height }: { height: number }) => {
  return <GalaxyWebhookSourceIcon height={height} />;
};

export default GalaxyWebhookIcon;
